<template lang="pug">
c-menu(theme='light', :activeindex='$route.path', @select='handleMenuSelect')
  c-menu-item(v-if="canAccess('dashboard')", index='/home', icon='icon-home', label='Inicio')
    c-menu-item(v-if="canAccess('oneplace')", index='/oneplace', icon='icon-truck', label='Terreno')
      c-menu-item(v-if="canAccess('create')", index='/create', icon='icon-file-text2', label='Ingreso')
        c-menu-item(v-if="canAccess('upload')", index='/upload', icon='icon-stack2', label='Carga masiva')
          c-menu-item(v-if="canAccess('assign')", index='/unassigned', icon='icon-download', label='Asignación')
            c-badge(type='info') {{dashtotals.assigned}}
          c-menu-item(v-if="canAccess('schedule')", index='/assigned', icon='icon-calendar', label='Agendamiento')
            c-badge(type='warning') {{dashtotals.scheduled}}
          c-menu-item(v-if="canAccess('management')", index='/management', icon='icon-cogs', label='Gestión')
            c-badge(type='info') {{dashtotals.processing}}
          c-menu-item(v-if="canAccess('management')", index='/map', icon='icon-location', label='Mapa')
            c-menu-item(v-if="canAccess('close')", index='/historic', icon='icon-books', label='Histórico')
              c-badge(type='danger') {{dashtotals.finished}}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Navigation',
  data () {
    return {
      permissions: []
    }
  },
  mounted () {
    const permissions = this.$store.getters['auth/getPermissions']
    if (permissions.length > 0) {
      this.permissions = permissions
    } else {
      this.$router.replace('/')
    }
    this.$options.sockets.changeState = (data) => {
      // subs one to the total
      if (data.task.state.order == 1 && data.task.substate.order == 1) {
        this.dashtotals.assigned -= 1
      } else if (data.task.state.order == 2) {
        this.dashtotals.scheduled -= 1
      } else if ((data.task.state.order == 3 && data.task.substate.order == 12) || (data.task.state.order == 4 && data.task.substate.order == 13) || (data.task.state.order == 4 && data.task.substate.order == 14) || (data.task.state.order == 5 && data.task.substate.order == 15)) {
        this.dashtotals.processing -= 1
      } else if (data.task.state.order = 5 && data.task.substate.order == 16) {
        this.dashtotals.finished -= 1
      }
      // add one to the total
      if (data.newstate.order == 1 && data.newsubstate.order == 1) {
        this.dashtotals.assigned += 1
      } else if (data.newstate.order == 2) {
        this.dashtotals.scheduled += 1
      } else if ((data.newstate.order == 3 && data.newsubstate.order == 12) || (data.newstate.order == 4 && data.newsubstate.order == 13) || (data.newstate.order == 4 && data.newsubstate.order == 14) || (data.newstate.order == 5 && data.newsubstate.order == 15)) {
        this.dashtotals.processing += 1
      } else if (data.newstate.order = 5 && data.newsubstate.order == 16) {
        this.dashtotals.finished += 1
      }
    }
  },
  methods: {
    ...mapActions('filter',[
      'setFilters', 'setBackendFilters', 'getBackendFilters', 'setDashTotals'
    ]),
    ...mapActions('tasks', [
      'totals'
    ]),
    handleMenuSelect (index) {
      this.$router.push(index)
    },
    canAccess (state) {
      return this.permissions.indexOf(state) > -1
    }
  },  
  computed: {
    ...mapGetters('filter', {
      dashtotals: 'getDashTotals',
      backendfilter: 'getBackendFilters'
    })
  },
  watch: {
     backendfilter: function (newval, oldval) {
      const f = this.$store.getters['filter/getBackendFilters']      
      this.totals(f).then(() => {
        let atotals = this.$store.getters['tasks/getTotals']
        this.setDashTotals({assigned: 0,scheduled: 0,processing: 0,finished: 0})
        for (let data of atotals) {
          if (data.state.order == 1 && data.substate.order == 1) {
            this.dashtotals.assigned += data.count
          } else if (data.state.order == 2) {
            this.dashtotals.scheduled += data.count
          } else if ((data.state.order == 3 && data.substate.order == 1) || (data.state.order == 3 && data.substate.order == 12) || (data.state.order == 4 && data.substate.order == 13) || (data.state.order == 4 && data.substate.order == 14) || (data.state.order == 5 && data.substate.order == 15)) {
            this.dashtotals.processing += data.count
          } else if (data.state.order = 5 && data.substate.order == 16) {
            this.dashtotals.finished += data.count
          }
        }
      })
     }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation.vue